<div *ngIf="shouldShowCTA()">
  <div class="query-table-cta" *ngIf="notifierName === 'airbrake-ruby'">
    <div class="query-table-cta__desc">
      <h3 class="query-table-cta__title">
        Database queries are affecting your application performance.
      </h3>
      <p>
        Find out which queries are slowing down your app with Query Analysis.
        Just update the
        <a href="https://rubygems.org/gems/airbrake" target="_blank"
          >airbrake gem to 9.5.0 or higher</a
        >.
      </p>
    </div>
    <div class="query-table-cta__info">
      <pre>
gem 'airbrake'
bundle update airbrake airbrake-ruby</pre
      >
    </div>
  </div>
  <div class="query-table-cta" *ngIf="notifierName === 'gobrake'">
    <div class="query-table-cta__desc">
      <h3 class="query-table-cta__title">
        Database queries are affecting your application performance.
      </h3>
      <p>
        Find out which queries are slowing down your app with Query Analysis.
        Just update the
        <a href="https://github.com/airbrake/gobrake/releases" target="_blank"
          >gobrake package to v4.0.0 or higher</a
        >.
      </p>
    </div>
    <div class="query-table-cta__info" *ngIf="notifierName === 'gobrake'">
      <pre>go get github.com/airbrake/gobrake/v5</pre>
    </div>
  </div>
  <div class="query-table-cta" *ngIf="notifierName === 'pybrake'">
    <div class="query-table-cta__desc">
      <h3 class="query-table-cta__title">
        Database queries are affecting your application performance.
      </h3>
      <p>
        Find out which queries are slowing down your app with Query Analysis.
        Just update the
        <a href="https://pypi.org/project/pybrake/" target="_blank"
          >python package to v0.4.0 or higher</a
        >.
      </p>
    </div>
    <div class="query-table-cta__info" *ngIf="notifierName === 'pybrake'">
      <pre>pip install -U pybrake</pre>
    </div>
  </div>
  <div class="query-table-cta__desc" *ngIf="notifierName === 'airbrake-js'">
    <div class="query-table-cta__desc">
      <h3 class="query-table-cta__title">
        Database queries are affecting your application performance.
      </h3>
      <p>
        Find out which queries are slowing down your app with Query Analysis.
        Just update the
        <a href="https://www.npmjs.com/package/airbrake-js" target="_blank"
          >airbrake-js package to v1.0.4 or higher</a
        >.
      </p>
    </div>
    <div class="query-table-cta__info">
      <pre>
npm install @airbrake/browser
# or
yarn upgrade @airbrake/browser</pre
      >
    </div>
  </div>
</div>
<div class="content-mask-container" *ngIf="!shouldShowCTA()">
  <h1 class="dash-title">
    <div class="paginate float-md-right">
      <div class="query-counter">
        {{ totalQueries }} {{ totalQueries | pluralize: "Query":"Queries" }},
        Page {{ currentPage }} of {{ totalPages }}
      </div>
      <div class="btn-group">
        <button
          class="btn"
          (click)="loadPage(currentPage - 1)"
          [disabled]="currentPage === 1 || totalPages === 0"
          type="button"
        >
          <i class="glyphicon glyphicon-angle-left"></i>
        </button>
        <button
          class="btn"
          (click)="loadPage(currentPage + 1)"
          [disabled]="currentPage >= totalPages"
          type="button"
        >
          <i class="glyphicon glyphicon-angle-right"></i>
        </button>
      </div>
    </div>
  </h1>
  <div class="content-mask" *ngIf="loading">
    <ab-spinner></ab-spinner>
  </div>
  <div class="ab-table-wrap">
    <div class="ab-table">
      <div class="ab-table__row-grid ab-table__row-grid--5-columns">
        <div class="ab-table__header"></div>
        <div class="ab-table__header"></div>
        <div class="ab-table__header"></div>
        <div class="ab-table__header ab-table__header--left-border">
          Response time (percentile)
        </div>
        <div class="ab-table__header"></div>
      </div>
    </div>
    <div class="ab-table">
      <div class="ab-table__row-grid ab-table__row-grid--5-columns">
        <div class="ab-table__header">
          <span class="th-link">Query</span>
          <input
            class="color--grey-400"
            type="text"
            placeholder="Filter queries"
            [disabled]="loading"
            [(ngModel)]="search"
            (ngModelChange)="debounceSearchQuery()"
          />
        </div>
        <div class="ab-table__header">
          <a class="th-link" (click)="sortBy('query')"
            >File<i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'query'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            ></i
          ></a>
        </div>
        <div class="ab-table__header">Function</div>
        <div class="ab-table__header ab-table__header--left-border">
          <a class="th-link" (click)="sortBy('stat.p50')"
            >50th<i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'stat.p50'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            ></i
          ></a>
        </div>
        <div class="ab-table__header">
          <a class="th-link" (click)="sortBy('stat.p95')"
            >95th<i
              class="glyphicon th-link__icon"
              *ngIf="sortColumn === 'stat.p95'"
              [ngClass]="{
                'glyphicon-caret-up': !sortDesc,
                'glyphicon-caret-down': sortDesc
              }"
            ></i
          ></a>
        </div>
      </div>
    </div>
    <div class="ab-table">
      <div
        class="ab-table__row-grid ab-table__row-grid--5-columns"
        *ngFor="let query of queries; trackBy: trackBy"
      >
        <div class="ab-table__cell">
          <div
            class="ab-sql-highlight"
            [innerHTML]="query.query | highlightSql"
          ></div>
        </div>
        <div class="ab-table__cell">
          <span
            >{{ query.file }}:<span class="color--warning">{{
              query.line
            }}</span></span
          >
        </div>
        <div class="ab-table__cell">{{ query.function }}</div>
        <div class="ab-table__cell">
          <ab-duration-format
            [milliseconds]="query.stat.p50"
          ></ab-duration-format>
        </div>
        <div class="ab-table__cell">
          <ab-duration-format
            [milliseconds]="query.stat.p95"
          ></ab-duration-format>
        </div>
      </div>
    </div>
  </div>
  <div class="blankslate" *ngIf="queries && queries.length === 0">
    <p class="blankslate__text">No data for the chosen time period</p>
    <img
      class="blankslate__image"
      src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/blankslate.svg"
    />
  </div>
</div>
